import { loadMetaData } from "../../../_metadata/ApiSpecList";

let init = false;

export function loadApiSpecList() {
	if (init) {
		return;
	}
	init = true;
	loadMetaData();
}
